<h2 class="mat-h2">Treatment used</h2>
<div echarts [options]="options"></div>
